import { ForwardedRef } from 'react';

/**
 * A utility function that helps in managing forwarded refs. This function assigns a DOM element
 * reference to the provided ref, whether it is a function or an object ref.
 */
export const refHandler = <T = HTMLElement>(ref: ForwardedRef<T>) => (r: T) => {
  if (typeof ref === 'function')
    ref(r);
  else if (ref)
    ref.current = r;
};
